import { AfterViewInit, Component, inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AccordionComponent } from "../../../../shared/components/accordion/accordion.component";
import { AuthorizeDirective } from '../../../../shared/authorization/authorize.directive.';
import { STATIC_DATA } from '../../../../shared/constants/static-data.constants';
import { Program } from '../../../../interfaces/user.interface';
import { LeadDetailsService } from '../../../../services/lead-details.service';
import { ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS, STATIC_JSON_DATA_PATH } from '../../../../shared/constants/static-data.constants';
import { SectionsService } from '../../../../services/sections.service';
import { EnrollmentSummaryResponseItem, ProviderHealthAssessment, ProviderHealthAssessmentResponseData, SummaryItem, TimeOffData } from '../../../../shared/interfaces/lead-details.service-types';
import { ChartModule } from 'primeng/chart';
import { NgZorroModule } from '../../../../shared/modules/ng-zorro/ng-zorro.module';
import { MEMBER_VIEW_PAGE_IDS } from '../../../../shared/constants/page.constants';
import { EditpdfComponent } from "../../../editpdf/editpdf.component";
import { PDFFormConfig } from '../../../../interfaces/config';
import { DialogConfig, DialogService } from '../../../../shared/services/dialog.service';
import { CheckListService } from '../../../../services/check-list.service';
import { DownloadFormPayload, DownloadFormPayloadItem } from '../../../../interfaces/checklist.model';
import { HttpResponse } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { LeadDetailSummaryTrainingTileComponent } from '../lead-detail-summary-training-tile/lead-detail-summary-training-tile.component';
import { environment } from '../../../../../environments/environment';
import { Router } from '@angular/router';
import { AdditionalDemographicsComponent } from '../../../leads/additional-demographics/additional-demographics.component';
import { take } from 'rxjs';
import { UserService } from '../../../../services/user.service';
import { SharedService } from '../../../../shared/services/shared.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { HEALTH_ASSESSMENT_VENDOR_URLS } from '../../../../shared/constants/url.constants';
import { StorageService } from '../../../../services/storage.service';
import { DropdownSelectComponent } from '../../../../shared/components/dropdown-select/dropdown-select.component';

interface WeeklyUtilizationEntry {
  orgName: string;
  svcCode: string;
  modifier?: string;
  svcDesc?: string;
  usedUnitsPercentage: number;
  availableUnitsText: string;
  startDate: string;
  endDate: string;
}

// Window for the 401(k) item in the Action Needed popup: 10/20/2026 through end of day 12/31/2026
const RETIREMENT_DOCS_ALERT_START = new Date(2026, 9, 20);
const RETIREMENT_DOCS_ALERT_END = new Date(2026, 11, 31, 23, 59, 59, 999);

@Component({
  selector: 'ppl-lead-detail-summary',
  standalone: true,
  imports: [AccordionComponent, AuthorizeDirective, ChartModule, NgZorroModule, EditpdfComponent, CommonModule, LeadDetailSummaryTrainingTileComponent,
    AdditionalDemographicsComponent, DropdownSelectComponent],
  templateUrl: './lead-detail-summary.component.html',
  styleUrl: './lead-detail-summary.component.css'
})
export class LeadDetailSummaryComponent implements OnInit, AfterViewInit {
  fieldsUpdated($event: any) {
    throw new Error('Method not implemented.');
  }
  private dialogSvc = inject(DialogService);
  @ViewChild('pdfDialog') pdfDialogRef!: TemplateRef<any>;
  @ViewChild('additionalDemographicsDialog') additionalDemographicsDialog!: TemplateRef<any>;
  @ViewChild('alertAdditionalDemographicsDialog') alertAdditionalDemographics!: TemplateRef<any>;
  @ViewChild('fraudAlertDialog') fraudAlertDialog!: TemplateRef<any>;
  @ViewChild('MOUAlertDialog') MOUAlertDialog!: TemplateRef<any>;
  @ViewChild('disputeResolutionAgreementDialog') disputeResolutionAgreementDialog!: TemplateRef<any>;
  @ViewChild('pbiReportDialog') pbiReportDialog!: TemplateRef<any>;

  @Input() readOnly = false;
  pageId = '';
  tabId = 'Summary';
  entry: string | null = '';
  selectedLead = 0;
  program?: Program;
  staticSummaryItems: SummaryItem[] = [];
  summaryItems: SummaryItem[] = [];
  staticAuthorizationItems: SummaryItem[] = [];
  authorizationItems: SummaryItem[] = [];
  staticApplicationInfoItems: SummaryItem[] = [];
  applicationInfoItems: SummaryItem[] = [];
  weeklyUtilizationData: any = [];
  timeOffUtilizationData!: Record<string, TimeOffData>;
  chartData: any;
  chartOptions: any;
  totalEarnings !: number;
  services = [
    {
      label: 'Support Broker Services',
      value: 'Support Broker Services'
    }
  ]

  participants = [
    {
      label: 'Nikhil',
      value: 'Nikhil'
    }
  ]

  payperiods = [
    {
      label: 'Nov 2, 2024 - Nov 14, 2024',
      value: 'Nov 2, 2024 - Nov 14, 2024'
    }
  ];
  pdfConfig?: PDFFormConfig;
  pdfFile?: string;
  pdfBlob?: Blob;
  showModal = false;
  modalBody = {
    associationModal: '',
    pdfViewer: ''
  };
  isParticipantFlow = false;
  isProviderFlow = false;
  isPA = false;
  associationMap: Record<string, string> = {};
  isDataLoaded: boolean = false;
  isWeeklyUtilizationSummaryPresent = false;
  isSameMco = true;
  wotcUrl: any;
  isPAOfferLetterDataLoaded: boolean = false;
  noOfPWCompleted: string = '';
  totalOfferLetters: string = '';
  filledInfo: any;
  viewDialogId: any;
  alertDialogId: any;
  offerLetterNeeded = false;
  retirementDocsAvailable = false;
  healthAssessmentScheduleLink: string = '';
  healthAssessments: ProviderHealthAssessment[] | null | undefined = null;
  healthAssessmentData: ProviderHealthAssessmentResponseData | null | undefined = null;
  healthAssessmentProgress: string = '';
  healthAssessmentDaysRemaining: number | null = null;
  isHrStaff : boolean = false;
  alertData: any;
  showAdditionalDialog = false;
  additionalDialogShownOnce = false;
  additionalDialogOpen = false;
  showFraudDialog = false;
  providerType: any;
  showWGAlert = false;
  WGAlert: any;
  MOUAlertData: any;
  showMOUDialog = false;
  participantPplId: any;
  isFraudOpen = false;
  isEmployerExternal = false;
  pendingEmployerPopups = false;
  disputeResolutionAgreementData: any;
  providerPplId = '';
  showMOUAlert = false;
  timeOffLabels: Record<string, string> = {
    pto: 'Safe and Sick Leave (SSL)',
    upst: 'Unpaid Sick Time'
  };
  locales = ['AR', 'BN', 'FR', 'DE', 'HT', 'IT', 'JA', 'KR','PL', 'PT', 'RU', 'ES', 'UR', 'YI','ZH' ];
  reverseLocales = ['AR', 'YI', 'UR'];
  reverseText = false;
  paSummaryData: any;
  isDRAAcknowledged = false;
  paTSViewData: { consumerName: string; serviceStartDate: string; serviceEndDate: string; statusDescription: string; statusCode: string; reasonCode: string; tasMasterPayrollScheduleId: number; participantPplId: string; servicePeriodId: number }[] = [];
  selectedPbiMonths: string = '';
  pbiDropdownOptions = [
    { attribute_text: '3 months', value: '3' },
    { attribute_text: '6 months', value: '6' },
    { attribute_text: '9 months', value: '9' },
    { attribute_text: '12 months', value: '12' },
    { attribute_text: '18 months', value: '18' },
    { attribute_text: '24 months', value: '24' },
  ];
  
  constructor(
    protected router: Router,
    private leadDetailsService: LeadDetailsService,
    private sectionService: SectionsService,
    private checkListService: CheckListService,
    private userService: UserService,
    private sharedService: SharedService,
    private timesheetService: TimesheetService,
    private storageService: StorageService
  ) { }


  ngOnInit(): void {
    this.program = this.userService.getSelectedProgram()!;
    this.providerType = this.getEnrollmentType();
    if (this.providerType == 'provider') {
      this.isPA = true;
    }
    this.showMOUAlert = this.program.roles.some((role: any) => (role.role_name === 'Employer (External)' || role.role_name === 'Participant (External)'));
    this.isEmployerExternal = this.program.roles.some((role: any) => role.role_name === 'Employer (External)');
    this.participantPplId = this.userService.getParticipantPplId()!;
    this.providerPplId = this.userService.getProviderPplId() ?? '';
    this.pageId = MEMBER_VIEW_PAGE_IDS[this.userService.getFirstSegment()!];
    this.entry = this.userService.getLeadEntry() ?? '';
    this.isParticipantFlow = this.userService.getLeadEntry() == 'participantEnrollment' || this.sectionService.getFlow() == 'participantEnrollment';
    this.isProviderFlow = this.entry === 'providerEnrollment';
    this.selectedLead = JSON.parse(this.userService.getSelectedLead()!);
    this.getStaticSummaryItems();
    this.wotcUrl = environment.wotcUrl;
    const userRoles = this.userService.getUserDetails()?.programs.find(pr => pr.program_code === this.program?.program_code)?.roles;
    this.isHrStaff = userRoles ? userRoles?.some(r => r.role_name === 'PPL HR Staff') : false;

    if (this.isPA) {
      this.getOfferLetterCount();
      this.getTimeOffData();
    }
    const selectedLocale = this.getGoogleTranslateLang()?.toUpperCase() ?? '';
    this.reverseText = this.reverseLocales.includes(selectedLocale);
    this.chartData = {
      labels: ['Submitted', 'Approved', 'Processing for Payment', 'Paid'],
      datasets: [
        {
          data: [0, 0, 1628.8, 254.5],
          backgroundColor: ['#b44bff', '#ffbd3e', '#4abaff', '#ff5f47'],
          hoverBackgroundColor: ['#b44bff', '#ffbd3e', '#4abaff', '#ff5f47']
        }
      ]
    };

    // Calculate total earnings
    this.totalEarnings = this.chartData.datasets[0].data.reduce((a: number, b: number) => a + b, 0);

    // Chart options configuration
    this.chartOptions = {
      plugins: {
        datalabels: {
          display: true,
          color: '#000', // Set label color
          font: {
            weight: 'bold',
            size: 14 // Customize font size as needed
          },
          formatter: (value: any, context: any) => `${context.chart.data.labels[context.dataIndex]}: $${value.toFixed(2)}`
        },
        legend: {
          position: 'right',
          labels: {
            font: {
              size: 14
            },
            color: '#666',
            formatter: (value: any, context: any) => `${context.chart.data.labels[context.dataIndex]}: $${value.toFixed(2)}`
          }
        },
        tooltip: {
          callbacks: {
            label: (tooltipItem: any) => {
              const label = this.chartData.labels[tooltipItem.dataIndex];
              const value = this.chartData.datasets[0].data[tooltipItem.dataIndex];
              return `$${value} ${label}`;
            }
          }
        }
      }
    };
  }

  getFraudAlert(){
    const type = (this.isProviderFlow) ? ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS[this.providerType]: 'CONS';
    const payload = {
      "userType": type,
      "alertType": "SM", 
      "recordId": this.selectedLead
    }
    this.sharedService.getFraudAlert(payload).subscribe((data:any)=>{
      if(data?.status === 200){
        this.alertData = data?.responsedata;
        if(this.alertData[0]?.alertId){
          this.showFraudDialog = true;
          if(!this.showAdditionalDialog){
            this.openFraudAlertDialog(type);
          }
        } else {
          this.showFraudDialog = false;
          if (this.showMOUDialog && !this.showAdditionalDialog) {
            this.openMOUAlertDialog(type);
          }
        }
      }
    })
  }

  getGoogleTranslateLang(): string | null {
    const match = document.cookie.match(/googtrans=\/[^/]+\/([^;]+)/);
    return match ? match[1] : null;
  }

  getMOUAlert(type: any) {
    const locale = this.getGoogleTranslateLang()?.toUpperCase() ?? '';
    const payload = {
      userType: type === 'CONS' ? 'EMP' : type,
      alertKey: "EMPAlertsKey",
      recordId: this.participantPplId,
      locale: this.locales.includes(locale) ? locale : 'EN'
    };
  
    this.sharedService.getAlerts(payload).subscribe((data: any) => {
      if (data?.status === 200) {
        this.MOUAlertData = data?.responsedata;
        if (this.MOUAlertData?.[0]?.alertId) {
          this.showMOUDialog = true;
          if (!this.showFraudDialog && !this.showAdditionalDialog) {
            this.openMOUAlertDialog(type);
          }
        }
      }
    });
  }

  getWGAlert(type: any) {
    const payload = {
      userType: type,
      alertType: 'WG',
      recordId: this.selectedLead,
    };
    this.sharedService.getFraudAlert(payload).subscribe((data: any) => {
      if (data?.status === 200) {
        this.WGAlert = data?.responsedata;
        if (this.WGAlert[0]?.alertId) {
          this.showWGAlert = true;
          if (!this.isPA) {
            this.showAdditionalDialog = true;
            this.alertForAdditionalDemographics();
          }
        }
      }
    });
  }

  ngAfterViewInit() {

    if (this.isEmployerExternal) {
      this.pendingEmployerPopups = true;
      this.getDisputeResolutionAgreement();
    }
    

    if (this.isPA) {
      this.getLeadData();
      this.getRetirementDocsAvailability();
    }
    if(this.isParticipantFlow || this.isProviderFlow){
      const type = (this.isProviderFlow) ? ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS[this.providerType]: 'CONS';
      if (type === 'CONS' || type === 'IR' || type === 'AR') {
        this.getWGAlert(type);
      }
      this.getFraudAlert();
      if (type === 'CONS' && this.showMOUAlert){
        this.getMOUAlert(type);
      }
    }
    if (this.isPA) {
      this.getLeadData();
    }
  }

  getLeadData() {
    this.leadDetailsService.getUpdatedLeadData().pipe(take(1)).subscribe((data) => {
      this.filledInfo =
        data?.responsedata?.infoData;
      // this.leadDetailsService.setLeadStatus(this.filledInfo?.applicationStatus);
      if (((!this.filledInfo?.isWotcCertified || this.filledInfo?.isPendingHealthAssessment || this.filledInfo?.isPendingNevvonTraining || this.filledInfo?.isOnHoldTraining) && !this.readOnly) 
        || (this.showWGAlert && !this.readOnly && this.isPA)) {
        this.showAdditionalDialog = true;
        this.alertForAdditionalDemographics();
      }
    });
  }

  /**
   * PAs who are Paperwork Complete with a consumer get an Action Needed item pointing to the Tax & 401 Documents tab,
   * shown only between RETIREMENT_DOCS_ALERT_START and RETIREMENT_DOCS_ALERT_END (inclusive, user's local date).
   */
  getRetirementDocsAvailability() {
    const now = new Date();
    if (now < RETIREMENT_DOCS_ALERT_START || now > RETIREMENT_DOCS_ALERT_END) return;
    this.leadDetailsService.getRetirementPlanDocuments(this.program?.program_code ?? '', this.selectedLead).subscribe((data: any) => {
      this.retirementDocsAvailable = !!data?.responsedata?.eligible && (data?.responsedata?.documents?.length ?? 0) > 0;
      if (this.retirementDocsAvailable && !this.readOnly && !this.showAdditionalDialog && !this.additionalDialogShownOnce) {
        this.showAdditionalDialog = true;
        this.alertForAdditionalDemographics();
      }
    });
  }

  fetchSummaryItemCountData() {
    const userType = this.entry === 'participantEnrollment' ? 'participant' : 'provider';
    this.leadDetailsService.getEnrollmentSummary(this.program?.program_code ?? '', this.selectedLead, userType).subscribe({
      next: (data: any) => {
        console.log("summary response ", data);
        this.offerLetterNeeded = this.isPA && (data.responsedata?.isOfferLetterSignNeeded ?? false);
        if (this.offerLetterNeeded && !this.readOnly && !this.showAdditionalDialog && !this.additionalDialogShownOnce) {
          this.showAdditionalDialog = true;
          this.alertForAdditionalDemographics();
        }
        const associationItems: EnrollmentSummaryResponseItem[] = data?.responsedata?.associations;
        const authorizationItems: EnrollmentSummaryResponseItem[] = data?.responsedata?.authorizations;

        const applicationInfoItems: EnrollmentSummaryResponseItem[] = data?.responsedata?.applicationInfo;

        this.weeklyUtilizationData = this.parseWeeklyUtilizationData(data?.responsedata?.weeklyUtilization);

        this.healthAssessmentData = data?.responsedata?.healthAssessment;
        this.healthAssessments = this.healthAssessmentData?.assessments;
        this.healthAssessmentProgress = this.toTitleCase(this.healthAssessmentData?.mhProgress);
        this.healthAssessmentDaysRemaining = this.calculateHealthAssessmentDaysRemaining();
        this.healthAssessmentScheduleLink = this.healthAssessmentData?.schedulingLink ? this.healthAssessmentData.schedulingLink : this.healthAssessmentData?.vendor === 'IMA' ? HEALTH_ASSESSMENT_VENDOR_URLS.IMA_LANDING_URL : HEALTH_ASSESSMENT_VENDOR_URLS.MOBILEHEALTH_LANDING_URL;
        this.paSummaryData = data?.responsedata?.paSummaries;
        if (this.isPA) {
          const paTSView = data?.responsedata?.paTSView;
          this.paTSViewData = paTSView ?? [];
          this.isDRAAcknowledged = data?.responsedata?.isDRAAcked;
        }

        let associationValueMap: Record<string, string> = {};
        let authorizationValueMap: Record<string, string> = {};

        let applicationValueMap: Record<string, string> = {};

        associationValueMap = associationItems.reduce((acc, cur) => {
          acc[cur.typeCode] = cur.typeValue;
          return acc;
        }, associationValueMap);

        this.associationMap = associationValueMap;

        this.summaryItems = this.staticSummaryItems.map(item => {
          return {
            ...item,
            summaryItemValue: associationValueMap[item.summaryItemKey] || 0
          }
        });

        // participant specific properties
        if (authorizationItems) {

          authorizationValueMap = authorizationItems.reduce((acc, cur) => {
            acc[cur.typeName] = cur.typeValue;
            return acc;
          }, authorizationValueMap);

          this.authorizationItems = this.staticAuthorizationItems.map(item => {
            return {
              ...item,
              summaryItemValue: authorizationValueMap[item.summaryItemDisplayName] || 0
            }
          });
        }

        // participant specific properties
        if (applicationInfoItems) {
          applicationValueMap = applicationInfoItems.reduce((acc, cur) => {
            acc[cur.typeName] = cur.typeValue;
            return acc;
          }, applicationValueMap);

          this.applicationInfoItems = this.staticApplicationInfoItems.map(item => {
            return {
              ...item,
              summaryItemValue: applicationValueMap[item.summaryItemDisplayName] || '-'
            }
          })
        }

        this.isDataLoaded = true;
      },
      error: () => {
        console.log("error occured during calculating summary", this.staticSummaryItems);
        this.summaryItems = [...this.staticSummaryItems];
        this.isDataLoaded = true;
      }
    })
  }

  private toTitleCase(value: string | undefined | null): string {
    if (!value) return '';
    // Normalize: replace non-alphanumeric sequences with a single space, trim
    const words = value.replace(/[^a-zA-Z0-9]+/g, ' ').trim().split(/\s+/);
    if (words.length === 0) return '';
    // Title case each word: first letter uppercase, rest lowercase
    return words
      .map(w => {
        const lower = w.toLowerCase();
        return lower.charAt(0).toUpperCase() + lower.slice(1);
      })
      .join(' ');
  }

  parseWeeklyUtilizationData(weeklyUtilizationData: any) {
    let parsedData: any = [];
    if (weeklyUtilizationData !== null && weeklyUtilizationData !== undefined) {
      this.isWeeklyUtilizationSummaryPresent = true;
      if (weeklyUtilizationData.length > 0) {
        const entries = weeklyUtilizationData as WeeklyUtilizationEntry[];
        const firstMcoName = entries[0]?.orgName;
        this.isSameMco = entries.every(entry => entry.orgName === firstMcoName);

        if (this.isSameMco) {
          parsedData = entries.map(entry => {
            const isActive = this.isActiveForCurrentWeek(entry.startDate, entry.endDate);
            return {
              mcoName: entry.orgName,
              serviceCode: entry.svcCode,
              modifier: entry.modifier,
              description: entry.svcDesc,
              utilization: entry.usedUnitsPercentage,
              availableUnits: entry.availableUnitsText,
              startDate: entry.startDate,
              endDate: entry.endDate,
              isActiveForCurrentWeek: isActive
            };
          }).sort((a: { startDate: string }, b: { startDate: string }) => {
            if (!a.startDate) return 1;
            if (!b.startDate) return -1;
            return new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
          });
        }
      }
    }
    return parsedData;
  }

  isActiveForCurrentWeek(startDate: string, endDate: string): boolean {
    if (!startDate || !endDate) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const start = new Date(startDate);
    start.setHours(0, 0, 0, 0);
    const end = new Date(endDate);
    end.setHours(23, 59, 59, 999);
    return start <= today && today <= end;
  }

  getTimeOffData(){
    this.timesheetService.getTimeOffDetails(this.program?.program_code ?? '', this.selectedLead).subscribe((data: any)=>{
      if(data.status === 200) {
      this.timeOffUtilizationData = data.responsedata;
      }
    })
  }


  getOfferLetterCount() {
    this.isPAOfferLetterDataLoaded = false;
    this.leadDetailsService.getPAOfferLettersCount(this.program?.program_code ?? '', this.selectedLead).subscribe({
      next: (response: any) => {
        const { total, pwComplete } = response.responsedata;
        this.noOfPWCompleted = pwComplete;
        this.totalOfferLetters = total;
        this.isPAOfferLetterDataLoaded = true;
      },
      error: (err) => {
        console.log("error occured during PA Offer letter count", err);
        this.isPAOfferLetterDataLoaded = false;
      }
    });
  }

  async getStaticSummaryItems() {
    const summaryItemsData = await this.sectionService.getJsonConfigurationData(
      STATIC_JSON_DATA_PATH.ENROLLMENT_SUMMARY_ITEMS,
      this.entry
    );
    this.staticSummaryItems = summaryItemsData.summaryItems as SummaryItem[];
    this.staticAuthorizationItems = summaryItemsData.authorizationsItems as SummaryItem[];
    this.staticApplicationInfoItems = summaryItemsData.applicationInfoItems as SummaryItem[];
    this.fetchSummaryItemCountData();
  }

  viewWelcomeLetter(event?: MouseEvent) {
    if (event) event.preventDefault();
    this.showModal = true;
    this.modalBody.pdfViewer = 'Welcome Letter';

    const form = {
      formMasterId: this.entry === 'participantEnrollment' ? 71 : 72,
      formDesc: 'Welcome Letter',
      form_name: 'Welcome Letter',
      formVersion: 0
    };

    this.pdfConfig = {
      form_id: form.formMasterId + '',
      is_mandatory: false,
      form_description: form.formDesc,
      form_name: form.form_name,
      fields: []
    };
    const dialogConfig: DialogConfig = {
      title: this.modalBody.pdfViewer,
      isOkText: 'Save',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    }

    this.dialogSvc.openDialog(this.pdfDialogRef, dialogConfig, () => this.handleCancel(), () => this.handleCancel());


    this.loadPDF(form);
  }

  handleCancel() {
    this.isFraudOpen = false; 
    this.showModal = false;
    this.pdfConfig = undefined;
    this.pdfFile = undefined;
    this.showFraudDialog = false;
    this.showMOUDialog = false;
    this.showAdditionalDialog = false;
    this.showWGAlert = false;
  }

  loadPDF(form: any) {
    this.checkListService.getPDF(this.program?.program_code ?? '', form.formMasterId, form.formVersion, 'EN').subscribe((response: HttpResponse<Blob>) => {
      if (response.body) {
        const blob = new Blob([response.body], { type: response.body.type });
        this.pdfBlob = blob;
        this.pdfFile = window.URL.createObjectURL(blob);
      }
    });
  }


  handleDownload() {
    const pdfPayload: DownloadFormPayloadItem[] = [];
    const forms = [{
      formMasterId: this.entry === 'participantEnrollment' ? 71 : 72,
      formDesc: 'Welcome Letter',
      form_name: 'Welcome Letter',
      formVersion: 0
    }];

    forms.forEach(f => {
      if (f.formMasterId != 0) {
        const payload: any = {
          formId: f.formMasterId + '',
          programCode: this.program?.program_code,
          languageCode: 'EN',
          formVersion: f.formVersion
        };

        pdfPayload.push(payload);
      }
    });

    const formPayload: DownloadFormPayload = {
      forms: [...pdfPayload]
    };

    this.checkListService.downloadPDFForm(formPayload, "Welcome_Letter" + '_forms.zip');
  }

  viewDisputeResolutionAgreement(event?: MouseEvent) {
    if (event) event.preventDefault();
    this.showModal = true;
    this.modalBody.pdfViewer = 'Dispute Resolution Agreement';

    const form = {
      formMasterId: 84,
      formDesc: 'Dispute Resolution Agreement',
      form_name: 'Dispute Resolution Agreement',
      formVersion: 0
    };

    this.pdfConfig = {
      form_id: form.formMasterId + '',
      is_mandatory: false,
      form_description: form.formDesc,
      form_name: form.form_name,
      fields: []
    };
    const dialogConfig: DialogConfig = {
      title: this.modalBody.pdfViewer,
      isOkText: 'Save',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(this.pdfDialogRef, dialogConfig, () => this.handleCancel(), () => this.handleCancel());
    this.loadPDF(form);
  }

  handleDRADownload() {
    const pdfPayload: DownloadFormPayloadItem[] = [];
    const forms = [{
      formMasterId: 84,
      formDesc: 'Dispute Resolution Agreement',
      form_name: 'Dispute Resolution Agreement',
      formVersion: 0
    }];

    forms.forEach(f => {
      if (f.formMasterId != 0) {
        const payload: DownloadFormPayloadItem = {
          formId: f.formMasterId + '',
          programCode: this.program?.program_code,
          languageCode: 'EN',
          formVersion: f.formVersion
        };
        pdfPayload.push(payload);
      }
    });

    const formPayload: DownloadFormPayload = {
      forms: [...pdfPayload]
    };

    this.checkListService.downloadPDFForm(formPayload, 'Dispute_Resolution_Agreement.zip');
  }

  getEnrollmentType() {
    const enrollTypeString = this.sectionService.getEnrollmentType();
    const assoctype = this.sectionService.getAssocType();
    const enrollType = enrollTypeString?.length ? enrollTypeString : (assoctype?.length ? assoctype : '');
    let enrollmentType;
    if (enrollType && Array.isArray(enrollType)) {
      if (enrollType.length > 1) {
        if (enrollType.includes('provider')) {
          enrollmentType = ['provider'];
        } else if (enrollType.includes('authRepresentative')) {
          enrollmentType = ['authRepresentative'];
        } else if (enrollType.includes('poa')) {
          enrollmentType = ['poa'];
        } else if (enrollType.includes('legalGuardian')) {
          enrollmentType = ['legalGuardian'];
        }
      } else {
        enrollmentType = enrollType[0];
      }
    } else {
      enrollmentType = null;
    }

    return enrollmentType;
  }

  navigateToAuth() {
    this.sectionService.changeTab('Authorizations');
    const currentUrl = this.router.url.split('?')[0];
    const authUrl = currentUrl.substring(0, currentUrl.lastIndexOf('/')) + '/authorizations';
    this.router.navigate([authUrl]);
  }

  navigateToTimesheets() {
    this.sectionService.changeTab('timesheets');
    const currentUrl = this.router.url.split('?')[0];
    const url = currentUrl.substring(0, currentUrl.lastIndexOf('/')) + '/timesheets';
    this.router.navigate([url]);
  }

  navigateToPendedTimesheetsWithRow(row: { statusCode: string; participantPplId: string; servicePeriodId: number; tasMasterPayrollScheduleId: number }) {
    if(environment.isExternal) {
      return;
    }
    
    const baseUrl = '/' + this.router.url.split('/')[1];
    this.router.navigate([baseUrl + '/pendedTimesheets'], {
      queryParams: { providerPPLId: this.participantPplId, consumerPPLId: row.participantPplId, processStatus: row.statusCode, servicePeriodId: row.servicePeriodId }
    });
  }

  navigateToFormsTab() {
    this.dialogSvc.closeDialog(this.alertDialogId);
    this.sectionService.changeTab('forms');
    const currentUrl = this.router.url.split('?')[0];
    const formsUrl = currentUrl.substring(0, currentUrl.lastIndexOf('/')) + '/forms';
    this.router.navigate([formsUrl]);
  }

  navigateToTaxDocumentsTab(event?: Event) {
    event?.preventDefault();
    this.dialogSvc.closeDialog(this.alertDialogId);
    this.sectionService.changeTab('taxDocuments');
    const currentUrl = this.router.url.split('?')[0];
    const taxDocumentsUrl = currentUrl.substring(0, currentUrl.lastIndexOf('/')) + '/taxDocuments';
    this.router.navigate([taxDocumentsUrl]);
  }

  navigateToAssociations() {
    const tab = this.entry === 'participantEnrollment' ? 'Associations' : 'associations'
    this.sectionService.changeTab(tab);
    const currentUrl = this.router.url.split('?')[0];
    const url = currentUrl.substring(0, currentUrl.lastIndexOf('/')) + '/associations';
    this.router.navigate([url]);
  }

  navigateToForms() {
    this.sectionService.changeTab('forms');
    this.router.navigate(['/home/providerEnrollmentList/details/forms']);
  }

  handleLinkKeydown(event: KeyboardEvent, context: string): void {
    if(!environment.isExternal) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        if (context === 'offerLetters' || context === 'formsTab') {
          this.navigateToForms();
        }
        if (context === 'associationsTab') {
          this.navigateToAssociations();
        }
        if (context === 'authTab') {
          this.navigateToAuth();
        }
        if (context === 'timesheetsTab') {
          this.navigateToTimesheets();
        }
      }
    }
  }

  openPbiReportPopup() {
    const dialogConfig: DialogConfig = {
          title: 'Generate Report',
          isOkText: 'Save',
          size: 'medium',
          position: 'top',
          showClose: true,
          showButtons: true,
        };
    
        this.dialogSvc.openDialog(
          this.pbiReportDialog,
          dialogConfig,
          () => this.handlepbiDownload(this.selectedPbiMonths),
          () => this.handleCancel()
        );
  }

  handlepbiDownload(months: any) {
    const providerId = environment.isExternal ? this.providerPplId : this.storageService.getProviderPPLId();
      const reportPayload = {
    employeeId: providerId,
    programCode: "NY CDPAP",
    lookbackMonths: months
      }

  
      this.checkListService.downloadPBIReport(reportPayload,  "Bi_report" + '_forms.zip');
    }

  openAdditionalDemographicsPopup() {
    const dialogConfig: DialogConfig = {
      title: 'Additional Demographics',
      isOkText: 'Ok',
      size: 'large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.viewDialogId = this.dialogSvc.openDialog(
      this.additionalDemographicsDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  alertForAdditionalDemographics() {
    if (this.pendingEmployerPopups) return;
    // Several async checks can trigger this popup; if it's already open, items arriving later render through the template flags
    if (this.additionalDialogOpen) return;
    this.additionalDialogOpen = true;
    this.additionalDialogShownOnce = true;
    const dialogConfig: DialogConfig = {
      title: 'Action Needed',
      isOkText: 'Ok',
      size: 'medium-scroll',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.alertDialogId = this.dialogSvc.openDialog(
      this.alertAdditionalDemographics,
      dialogConfig,
      () => this.handleCancelAdditional(),
      () => this.handleCancelAdditional()
    );
  }

  handleCancelAdditional() {
    this.additionalDialogOpen = false;
    this.showModal = false;
    this.pdfConfig = undefined;
    this.pdfFile = undefined;
    this.showAdditionalDialog = false;
    if(this.showFraudDialog){
      const type = (this.isProviderFlow) ? ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS[this.providerType]: 'CONS';
      this.openFraudAlertDialog(type);
    }
    if(!this.showFraudDialog && this.showMOUDialog){
      const type = (this.isProviderFlow) ? ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS[this.providerType]: 'CONS';
      this.openMOUAlertDialog(type);
    }
  }

  handleFraudAlertCancel() {
    this.isFraudOpen = false; 
    this.showModal = false;
    this.pdfConfig = undefined;
    this.pdfFile = undefined;
    this.showAdditionalDialog = false;
    this.showFraudDialog = false;
    if(this.showMOUDialog){
      const type = (this.isProviderFlow) ? ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS[this.providerType]: 'CONS';
      this.openMOUAlertDialog(type);
    }
  }

  openFraudAlertDialog(type: any) {
    if (this.pendingEmployerPopups) return;
    if (this.isFraudOpen) return;
    this.isFraudOpen = true;
    const dialogConfig: DialogConfig = {
      title: 'Alert',
      isOkText: 'Acknowledge',
      size: 'medium-scroll',
      position: 'top',
      showClose: true,
      showOkButton: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.fraudAlertDialog,
      dialogConfig,
      () => this.acknowledgeAlert(type, 'fraud'),
      () => this.handleFraudAlertCancel()
    );
  }

  openMOUAlertDialog(type: any) {
    if (this.pendingEmployerPopups) return;
    if (this.isFraudOpen) return;
    this.isFraudOpen = true;
      const dialogConfig: DialogConfig = {
        title: 'Alert',
        isOkText: 'Acknowledge',
        size: 'medium-scroll',
        position: 'top',
        showClose: false,
        showOkButton: true,
        showButtons: false,
      };

    this.dialogSvc.openDialog(
      this.MOUAlertDialog,
      dialogConfig,
      () => this.acknowledgeAlert(type, 'MOU'),
      () => this.handleCancel()
    );
  }

  getDisputeResolutionAgreement() {
    const locale = this.getGoogleTranslateLang()?.toUpperCase() ?? '';
    const payload = {
      userType: 'IR',
      alertKey: 'IRAlertsKey',
      recordId: this.providerPplId,
      locale: this.locales.includes(locale) ? locale : 'EN'
    };
    this.sharedService.getAlerts(payload).subscribe((data: any) => {
      if (data?.status === 200) {
        this.disputeResolutionAgreementData = data?.responsedata;
        if (this.disputeResolutionAgreementData?.[0]?.alertId) {
          this.openPayrollProblemsAgreementPopup();
        } else {
          this.pendingEmployerPopups = false;
          this.triggerExistingPopupChain();
        }
      } else {
        this.pendingEmployerPopups = false;
        this.triggerExistingPopupChain();
      }
    });
  }

  openPayrollProblemsAgreementPopup() {
    const dialogConfig: DialogConfig = {
      title: 'Dispute Resolution Agreement',
      isOkText: 'Acknowledge',
      size: 'medium-scroll',
      position: 'top',
      showClose: this.disputeResolutionAgreementData?.[0]?.isCBTNeeded ?? false,
      showOkButton: this.disputeResolutionAgreementData?.[0]?.isAckNeeded ?? false,
      showButtons: false,
      stickyFooter: true,
    };
    this.dialogSvc.openDialog(
      this.disputeResolutionAgreementDialog,
      dialogConfig,
      () => this.acknowledgeDisputeResolutionAgreement(),
      () => {
        this.pendingEmployerPopups = false;
        this.triggerExistingPopupChain();
      }
    );
  }

  acknowledgeDisputeResolutionAgreement() {
    const payload = this.disputeResolutionAgreementData.map((item: any) => ({
      programCode: this.program?.program_code,
      alertId: item.alertId,
      userType: item.userType,
      recordId: this.providerPplId
    }));
    this.sharedService.acknowledgeFraudAlert(payload).subscribe(() => {
      this.isDRAAcknowledged = true;
      this.pendingEmployerPopups = false;
      this.triggerExistingPopupChain();
    });
  }

  triggerExistingPopupChain() {
    const type = this.isProviderFlow ? ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS[this.providerType] : 'CONS';
    if (this.showAdditionalDialog) {
      this.alertForAdditionalDemographics();
    } else if (this.showFraudDialog) {
      this.openFraudAlertDialog(type);
    } else if (this.showMOUDialog) {
      this.openMOUAlertDialog(type);
    }
  }

  acknowledgeAlert(type: any, alertType: any){
    let payload = {};
    if(alertType === 'fraud'){
      payload = this.alertData.map((item: any) => ({
        alertId: item.alertId,
        userType: item.userType,
        recordId: item.recordId
      }));
    }
    else{
      payload = this.MOUAlertData.map((item: any) => ({
        programCode: this.program?.program_code,
        alertId: item.alertId,
        userType: item.userType === 'CONS' ? 'EMP' : item.userType,
        recordId: this.participantPplId
      }));
    }

    this.sharedService.acknowledgeFraudAlert(payload).subscribe((data: any)=>{
      if(alertType === 'fraud' && this.showMOUDialog){
        this.openMOUAlertDialog(type);
      }
      else{
        this.handleCancel();
      }
    })
  }

  handlePopUpClose() {
    this.dialogSvc.closeDialog(this.viewDialogId);
    if (this.filledInfo) {
      this.filledInfo.isWotcCertified = true
    }
  }

  private calculateHealthAssessmentDaysRemaining(): number | null {
    if (!this.healthAssessments) return null;
    const active = this.healthAssessments.find(item => item.is_active);
    if (!active?.end_date) return null;
    const endDate = new Date(active.end_date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    const diffMs = endDate.getTime() - today.getTime();
    return Math.max(0, Math.ceil(diffMs / (1000 * 60 * 60 * 24)));
  }

  getUtilizationClass(utilization: number): string {
    if (utilization > 90) return 'high-util';
    if (utilization > 60 && utilization <= 90) return 'medium-util';
    return 'low-util';
  }
  handleActivateLikeButton(event: KeyboardEvent) {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    this.openAdditionalDemographicsPopup();
  }
}
  getTileAriaLabel(displayName: string, value: number | string | null | undefined): string {
    const n = (typeof value === 'number')
      ? value
      : Number.isFinite(Number(value)) ? Number(value) : 0;

    let base = (displayName || '').trim();

    if (/^POA(\(s\))?$/i.test(base)) {
      const letters = 'POA';
      const plural = n === 1 ? '' : 's';
      return `${letters}${plural} ${n}`;
    }
    base = base.replace(/\(s\)\s*$/i, 's');

    return `${base} ${n}`;
  }
}
